import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyQrConnect = lazy(() => import('./QrConnect'));

export const qrConnectRoute: RouteObject = {
  path: '/connect/:accountKey',
  element: (
    <Suspense fallback={<PageLoading />}>
      <LazyQrConnect />
    </Suspense>
  ),
};
